module.exports = __webpack_public_path__ + "assets/img/favicon/favicon.f3bb6314ebe52feacf51844e70b00562.ico";